export class BadRequestError extends Error {
  constructor(message = '400', eventId, popUp) {
    super(message)
    this.name = 'BadRequestError'
    this.status = 400
    this.eventId = eventId
    this.popUp = popUp
    this.report = false
  }
}
